import baseAPI from '@/http'

const router = 'api/solucao-tipo'


export const tipoSolucaoAPI = {
  create: (data) => baseAPI.post(router, data),
  update: (data) => baseAPI.put(router, data),
  delete: (id) => baseAPI.delete(`${router}/${id}`),
  get: (id) => baseAPI.get(`${router}/${id}`),
  list: () => baseAPI.get(router),

}
